import {
  measureElement as defaultMeasureElement,
  type Virtualizer,
} from "@tanstack/react-virtual";

export function rowMeasure(
  element: Element,
  entry: ResizeObserverEntry | undefined,
  instance:
    Virtualizer<Element, Element> | Virtualizer<HTMLDivElement, Element>,
  fallback: (index: number) => number
): number {
  const measured = defaultMeasureElement(
    element,
    entry,
    instance as Virtualizer<Element, Element>
  );
  if (measured > 0) return measured;
  const index = instance.indexFromElement(element);
  if (index < 0) return fallback(0);
  const key = instance.options.getItemKey(index);
  return instance.itemSizeCache.get(key) ?? fallback(index);
}
